import { useEffect, useState } from 'react';
import api from '../api';

export function useBekleyenBirlestirmeSayisi(aktif: boolean = true) {
  const [sayi, setSayi] = useState(0);

  useEffect(() => {
    if (!aktif) return;
    const kontrol = () => {
      api.get('/api/auth/merge-requests?count=1')
        .then(r => setSayi(Number(r.data.count) || 0))
        .catch(() => {});
    };
    kontrol();
    const interval = setInterval(kontrol, 60000);
    return () => clearInterval(interval);
  }, [aktif]);

  return sayi;
}
